import { render, staticRenderFns } from "./ZuButtonUpload.vue?vue&type=template&id=588418b0&scoped=true"
import script from "./ZuButtonUpload.vue?vue&type=script&lang=js"
export * from "./ZuButtonUpload.vue?vue&type=script&lang=js"
import style0 from "./ZuButtonUpload.vue?vue&type=style&index=0&id=588418b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588418b0",
  null
  
)

export default component.exports